import store from "@/store";
const dynamicConfig = localStorage.getItem("dynamicConfig");
export const upLoadUrl =
  JSON.parse(dynamicConfig).server_url +
  "/app-api/person/member-person-app/upload";

export const uploadHeaders = {
  "tenant-id": 1,
  Authorization: `Bearer ${
    store.state.user.token ? store.state.user.token : null
  }`,
};

export const uploadData = {
  path:'memberperson/person/'
}
